import React, { useState, useEffect } from "react";
import { StaffSideMenu } from "../../staff/StaffSideMenu";
import API_URL from "../../../api/API";
import { useStaffAuthContext } from "../../staff/useStaffAuthContext";
import { useParams } from "react-router-dom";
import MultiSelectExerciseList from "../../component/MultiSelectExerciseList";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { DndContext, useDroppable, useDraggable } from "@dnd-kit/core";
import { arrayMove } from "@dnd-kit/sortable";
import { GoArrowLeft } from "react-icons/go";
import { FiEdit2 } from "react-icons/fi";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { RiDeleteBin4Line } from "react-icons/ri";
import { HiOutlinePlusSm } from "react-icons/hi";
import { MdAdd, MdKeyboardArrowRight, MdKeyboardArrowUp } from "react-icons/md";
import { FaCheck } from "react-icons/fa";

const DotedSvg = () => {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.99967 8.66732C6.36786 8.66732 6.66634 8.36884 6.66634 8.00065C6.66634 7.63246 6.36786 7.33398 5.99967 7.33398C5.63148 7.33398 5.33301 7.63246 5.33301 8.00065C5.33301 8.36884 5.63148 8.66732 5.99967 8.66732Z"
          stroke="#364153"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.99967 3.99935C6.36786 3.99935 6.66634 3.70087 6.66634 3.33268C6.66634 2.96449 6.36786 2.66602 5.99967 2.66602C5.63148 2.66602 5.33301 2.96449 5.33301 3.33268C5.33301 3.70087 5.63148 3.99935 5.99967 3.99935Z"
          stroke="#364153"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.99967 13.3333C6.36786 13.3333 6.66634 13.0349 6.66634 12.6667C6.66634 12.2985 6.36786 12 5.99967 12C5.63148 12 5.33301 12.2985 5.33301 12.6667C5.33301 13.0349 5.63148 13.3333 5.99967 13.3333Z"
          stroke="#364153"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.99967 8.66732C10.3679 8.66732 10.6663 8.36884 10.6663 8.00065C10.6663 7.63246 10.3679 7.33398 9.99967 7.33398C9.63148 7.33398 9.33301 7.63246 9.33301 8.00065C9.33301 8.36884 9.63148 8.66732 9.99967 8.66732Z"
          stroke="#364153"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.99967 3.99935C10.3679 3.99935 10.6663 3.70087 10.6663 3.33268C10.6663 2.96449 10.3679 2.66602 9.99967 2.66602C9.63148 2.66602 9.33301 2.96449 9.33301 3.33268C9.33301 3.70087 9.63148 3.99935 9.99967 3.99935Z"
          stroke="#364153"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.99967 13.3333C10.3679 13.3333 10.6663 13.0349 10.6663 12.6667C10.6663 12.2985 10.3679 12 9.99967 12C9.63148 12 9.33301 12.2985 9.33301 12.6667C9.33301 13.0349 9.63148 13.3333 9.99967 13.3333Z"
          stroke="#364153"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
};

export const AdminEditWarmupRoutineTemplate = () => {
  const { staff } = useStaffAuthContext();
  const { template_id } = useParams(); // Get template ID from URL
  const [exercises, setExercises] = useState([]);
  const [selectedExercises, setSelectedExercises] = useState([]);
  const [phase, setPhase] = useState("");
  const [templateName, setTemplateName] = useState("");
  const [editingTitle, setEditingTitle] = useState(false);
  const [newTemplateName, setNewTemplateName] = useState("");

  const [loading, setLoading] = useState(false);
  const [savingTemplate, setSavingTemplate] = useState(false);

  const [resetTrigger, setResetTrigger] = useState(false);

  const [warmupPhases, setWarmupPhases] = useState([]);

  const [showRestForm, setShowRestForm] = useState(false);
  const [restNotes, setRestNotes] = useState("");
  const [restDuration, setRestDuration] = useState("");

  const [phaseForAddingExercises, setPhaseForAddingExercises] = useState(null);

  const [dragMode, setDragMode] = useState(false); // State to control drag mode

  const [reorderPhasesMode, setReorderPhasesMode] = useState(false);

  const [editingPhaseId, setEditingPhaseId] = useState(null);
  const [editedTitle, setEditedTitle] = useState("");

  const [addPhaseOpen, setAddPhaseOpen] = useState(false);

  const navigate = useNavigate(); // Initialize navigation

  // Fetch exercises
  useEffect(() => {
    const fetchExercises = async () => {
      try {
        const response = await fetch(API_URL.GET_EXERCISE_LIBRARY_LIST_ADMIN, {
          headers: { Authorization: `Bearer ${staff.token}` },
        });
        const data = await response.json();
        if (response.ok) setExercises(data.exercises);
      } catch (err) {
        console.error("Error fetching exercises:", err);
      }
    };

    fetchExercises();
  }, []);

  const fetchTemplateData = async () => {
    try {
      const response = await fetch(
        `${API_URL.ADMIN_GET_SPEED_TEMPLATE_WARMUP_ROUTINE_TEMPLATE}${template_id}`,
        {
          headers: { Authorization: `Bearer ${staff.token}` },
        },
      );
      const data = await response.json();
      console.log(data);
      if (response.ok && data.template) {
        setTemplateName(data.template.template_title || "Untitled Template");
        // Ensure warmupPhases contain all exercise fields on load
        const populatedPhases = (data.template.phases || []).map((phase) => ({
          ...phase,
          exercises: phase.exercises.map((exercise) => ({
            ...exercise,
            sets: exercise.sets || "",
            reps: exercise.reps || "",
            time: exercise.time || "None",
            distance: exercise.distance || "",
            rest: exercise.rest || "",
            notes: exercise.notes || "",
          })),
        }));

        setWarmupPhases(populatedPhases);
      }
    } catch (err) {
      console.error("Error fetching template name:", err);
    }
  };

  // Fetch template data
  useEffect(() => {
    if (template_id) fetchTemplateData();
  }, [template_id]);

  // Save updated template title
  const handleSaveTitle = async () => {
    if (!newTemplateName.trim()) {
      alert("Title cannot be empty.");
      return;
    }

    try {
      const response = await fetch(
        `${API_URL.ADMIN_SAVE_SPEED_TEMPLATE_TITLE}${template_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${staff.token}`,
          },
          body: JSON.stringify({ template_title: newTemplateName }),
        },
      );

      if (response.ok) {
        setTemplateName(newTemplateName);
        setEditingTitle(false);
      } else {
        alert("Failed to update template title.");
      }
    } catch (error) {
      console.error("Error updating template title:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  // Save Phase & Exercises
  const handleSave = async () => {
    if (!phase.trim()) {
      alert("Please enter a phase name.");
      return;
    }
    if (selectedExercises.length === 0) {
      alert("Please select at least one exercise.");
      return;
    }

    setLoading(true);

    const payload = {
      phase_title: phase,
      exercises: selectedExercises,
    };

    try {
      const response = await fetch(
        `${API_URL.ADMIN_POST_SPEED_TEMPLATE_WARMUP_ROUTINE_PHASEANDEXERCISES}${template_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${staff.token}`,
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();

      if (response.ok) {
        alert("Phase and exercises saved successfully!");
        setPhase(""); // Reset phase name
        setSelectedExercises([]); // Reset selected exercises
        // Trigger reset
        setResetTrigger((prev) => !prev);
        fetchTemplateData(); // 🔄 REFRESH DATA HERE
      } else {
        alert(data.error || "Failed to save.");
      }
    } catch (error) {
      console.error("Error saving phase:", error);
      alert("Something went wrong. Please try again.");
    }

    setLoading(false);
  };

  const handleDeleteExercise = async (phaseId, exerciseId) => {
    try {
      const response = await fetch(
        `${API_URL.ADMIN_DELETE_SPEED_TEMPLATE_WARMUP_ROUTINE_EXERCISE}${template_id}/${phaseId}/${exerciseId}`,
        {
          method: "DELETE",
          headers: { Authorization: `Bearer ${staff.token}` },
        },
      );

      if (response.ok) {
        alert("Exercise deleted successfully!");
        fetchTemplateData(); // 🔄 Refresh list after deletion
      } else {
        alert("Failed to delete exercise.");
      }
    } catch (err) {
      console.error("Error deleting exercise:", err);
      alert("Something went wrong. Please try again.");
    }
  };

  const handleDeletePhase = async (phaseId) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this phase?",
    );
    if (!isConfirmed) return;

    try {
      const response = await fetch(
        `${API_URL.ADMIN_DELETE_SPEED_TEMPLATE_WARMUP_ROUTINE_PHASE}${template_id}/${phaseId}`,
        {
          method: "DELETE",
          headers: { Authorization: `Bearer ${staff.token}` },
        },
      );

      if (response.ok) {
        alert("Phase deleted successfully!");
        fetchTemplateData(); // Refresh list after deletion
      } else {
        alert("Failed to delete phase.");
      }
    } catch (err) {
      console.error("Error deleting phase:", err);
      alert("Something went wrong. Please try again.");
    }
  };

  const handleFieldChange = (phaseIndex, exerciseIndex, field, value) => {
    const newPhases = [...warmupPhases];
    newPhases[phaseIndex].exercises[exerciseIndex][field] = value;
    setWarmupPhases(newPhases);
  };

  const handleSaveTemplate = async () => {
    //console.log(warmupPhases);

    if (savingTemplate) return; // Prevent duplicate requests
    setSavingTemplate(true);

    try {
      const payload = {
        phases: warmupPhases.map((phase) => ({
          phase_id: phase._id,
          title: phase.title,
          type: phase.type,
          rest_duration: phase.rest_duration,
          rest_notes: phase.rest_notes,

          exercises: phase.exercises.map((exercise) => ({
            exercise_id: exercise.exercise_id?._id,
            sets: exercise.sets,
            reps: exercise.reps,
            time: exercise.time,
            distance: exercise.distance,
            rest: exercise.rest,
            notes: exercise.notes,
          })),
        })),
      };

      console.log("Saving Template Data:", payload);

      const response = await fetch(
        `${API_URL.ADMIN_SAVE_SPEED_TEMPLATE_WARMUP_ROUTINE_ALL_DATA}${template_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${staff.token}`,
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();

      if (response.ok) {
        alert("Template saved successfully!");
      } else {
        alert(data.message || "Failed to save template.");
      }
    } catch (error) {
      console.error("Error saving template:", error);
      alert("An error occurred while saving.");
    } finally {
      setSavingTemplate(false);
    }
  };

  const handleSaveRest = async () => {
    if (!restDuration.trim()) {
      alert("Please enter rest duration.");
      return;
    }

    setLoading(true);

    const payload = {
      rest_notes: restNotes,
      rest_duration: restDuration,
    };

    try {
      const response = await fetch(
        `${API_URL.ADMIN_SAVE_SPEED_TEMPLATE_WARMUP_ROUTINE_PHASE_REST_DATA}${template_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${staff.token}`,
          },
          body: JSON.stringify(payload),
        },
      );

      if (response.ok) {
        alert("Rest period added successfully!");
        setRestNotes("");
        setRestDuration("");
        setShowRestForm(false);
        fetchTemplateData(); // Refresh UI
      } else {
        alert("Failed to save rest period.");
      }
    } catch (error) {
      console.error("Error saving rest period:", error);
      alert("Something went wrong. Please try again.");
    }

    setLoading(false);
  };

  const updatePhaseWithNewExercises = async (phaseId, selectedExercises) => {
    try {
      const response = await fetch(
        `${API_URL.ADMIN_SAVE_SPEED_TEMPLATE_WARMUP_ROUTINE_PHASE_ADD_MORE_EX}${template_id}/${phaseId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${staff.token}`,
          },
          body: JSON.stringify({ exercises: selectedExercises }),
        },
      );

      if (!response.ok) throw new Error("Failed to update exercises");

      alert("Exercises successfully added!");
      setSelectedExercises([]); // Reset selected exercises
      // Trigger reset
      setResetTrigger((prev) => !prev);
      fetchTemplateData(); // Refresh UI
    } catch (error) {
      console.error("Error updating phase exercises:", error);
    }
  };

  const handleEditPhaseTitle = (phaseId, currentTitle) => {
    setEditingPhaseId(phaseId);
    setEditedTitle(currentTitle);
  };

  const handleSavePhaseTitle = async (phaseId) => {
    try {
      const response = await fetch(
        `${API_URL.ADMIN_SAVE_SPEED_TEMPLATE_WARMUP_ROUTINE_PHASE_TITLE}${phaseId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${staff.token}`,
          },
          body: JSON.stringify({ title: editedTitle }),
        },
      );

      if (!response.ok) {
        throw new Error("Failed to update phase title");
      }

      const updatedPhase = await response.json();

      // Update local state if needed
      const updatedPhases = warmupPhases.map((phase) =>
        phase._id === phaseId ? { ...phase, title: updatedPhase.title } : phase,
      );
      setWarmupPhases(updatedPhases);

      setEditingPhaseId(null);
    } catch (error) {
      console.error("Error updating phase title:", error);
      alert("Failed to update phase title. Please try again.");
    }
  };

  // Toggle drag mode
  const toggleDragMode = () => {
    setDragMode((prev) => !prev);
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    setWarmupPhases((prevPhases) => {
      const newPhases = prevPhases.map((phase) => {
        const activeIndex = phase.exercises.findIndex(
          (ex) => ex._id === active.id,
        );
        const overIndex = phase.exercises.findIndex((ex) => ex._id === over.id);

        // ✅ Ignore if exercise is not in this phase
        if (activeIndex === -1 || overIndex === -1) return phase;

        // ✅ Reorder exercises within the same phase
        const newExercises = arrayMove(
          phase.exercises,
          activeIndex,
          overIndex,
        ).map((exercise, index) => ({
          ...exercise,
          order_id: index, // ✅ Ensure correct order_id assignment
        }));

        return { ...phase, exercises: newExercises };
      });

      // ✅ Call API once after all reordering is done

      return newPhases;
    });
  };

  const handlePhaseDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    // Find the current index and new index
    const oldIndex = warmupPhases.findIndex((phase) => phase._id === active.id);
    const newIndex = warmupPhases.findIndex((phase) => phase._id === over.id);

    if (oldIndex !== -1 && newIndex !== -1) {
      // Reorder the array
      const updatedPhases = [...warmupPhases];
      const [movedPhase] = updatedPhases.splice(oldIndex, 1);
      updatedPhases.splice(newIndex, 0, movedPhase);

      // Update state with new order
      setWarmupPhases(updatedPhases);
    }
  };

  const toggleReorderPhasesMode = () => {
    setReorderPhasesMode(!reorderPhasesMode);
  };

  const [expandedPhases, setExpandedPhases] = useState({});

  const togglePhaseExpansion = (phaseId) => {
    setExpandedPhases((prev) => ({
      ...prev,
      [phaseId]: !prev[phaseId],
    }));
  };

  return (
    <div className="flex md:h-screen font-inter">
      <StaffSideMenu />
      <div className="max-md:w-full md:flex-1 flex flex-col bg-bgBase">
        {/* Go Back Button */}
        <div className="bg-white pt-5 pb-3 md:py-6 px-5 md:px-10 xl:px-14">
          <div className="w-full max-w-[1336px]">
            <div className="flex flex-wrap justify-between items-center gap-5">
              <div className="flex items-center justify-between">
                {editingTitle ? (
                  <div className="w-full flex flex-col gap-2">
                    <input
                      type="text"
                      value={newTemplateName}
                      onChange={(e) => setNewTemplateName(e.target.value)}
                      className="p-2 bg-white border border-tblBorder rounded-md w-full font-medium"
                      onKeyDown={(e) => e.key === "Enter" && handleSaveTitle()}
                    />
                    <div className="flex gap-2">
                      <button
                        onClick={handleSaveTitle}
                        className="px-6 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-none rounded-lg hover:bg-black capitalize"
                      >
                        Save
                      </button>
                      <button
                        onClick={() => {
                          setEditingTitle(false);
                          setNewTemplateName(templateName);
                        }}
                        className="bg-white border border-tblBorder rounded-10 py-2.5 px-5 text-dark font-inter font-medium text-sm leading-tight capitalize hover:bg-dark hover:text-white transition"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="w-full flex items-center gap-2">
                    {templateName ? (
                      <>
                        <div className="w-full flex justify-between gap-5">
                          <h1 className="text-lg md:text-2xl font-medium">
                            {templateName}
                          </h1>
                          <button
                            onClick={() => {
                              setEditingTitle(true);
                              setNewTemplateName(templateName);
                            }}
                            className="flex-none p-2 rounded hover:bg-gray-200"
                          >
                            <FiEdit2 color="99A1AF" size={18} />
                          </button>
                        </div>
                      </>
                    ) : (
                      <h1 className="text-xl md:text-2xl font-medium text-slate100">
                        Loading Template...
                      </h1>
                    )}
                  </div>
                )}
              </div>

              <div className="flex items-center gap-5">
                <button
                  onClick={() => navigate(-1)}
                  className="text-slate100 font-inter font-normal text-sm leading-tight flex items-center gap-2 hover:underline max-md:ml-12"
                >
                  <GoArrowLeft color="#666666" /> Go Back
                </button>

                <button
                  className="px-6 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black"
                  onClick={handleSaveTemplate}
                  disabled={savingTemplate || warmupPhases.length === 0}
                >
                  {savingTemplate ? "Saving Template..." : "Save Template"}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="overflow-y-auto show-scrollbar w-full space-y-5 py-4 md:py-8 px-5 md:px-10">
          {/* Left: Warmup Phases & Exercises */}
          <div className="w-full max-w-[1336px] space-y-4">
            {/* Reorder Phases Button */}
            <div className="mb-4 flex max-md:flex-col md:justify-between md:items-center gap-5">
              <h2 className="text-dark text-lg font-medium">Warm-Up Phases</h2>
              <div className="flex items-center gap-3">
                {showRestForm ? (
                  <></>
                ) : (
                  <>
                    <button
                      onClick={() => setShowRestForm(!showRestForm)}
                      className="px-4 py-2.5 flex items-center gap-2 bg-white hover:bg-tblHead border border-tblBorder text-dark text-base font-medium rounded-xl"
                    >
                      <HiOutlinePlusSm color="#000" size={16} />
                      Add Rest
                    </button>
                  </>
                )}
                {warmupPhases.length > 1 && (
                  <button
                    onClick={toggleReorderPhasesMode}
                    className="px-4 py-2.5 flex items-center gap-2 bg-white hover:bg-tblHead border border-tblBorder text-dark text-base font-medium rounded-xl"
                  >
                    {reorderPhasesMode ? (
                      "Done Reordering"
                    ) : (
                      <>
                        {" "}
                        <DotedSvg /> Reorder
                      </>
                    )}
                  </button>
                )}
              </div>
            </div>

            {/* Add Rest Section (Below Save Button) */}
            <div className="mt-6">
              {/* Rest Form (Only Show When Button is Clicked) */}
              {showRestForm && (
                <div className="bg-white border border-black/10 rounded-10 py-4 px-5">
                  <h2 className="text-lg font-medium mb-2">Add Rest Period</h2>

                  {/* Rest Notes Input */}
                  <div className="flex flex-col gap-4">
                    <div className="flex flex-col gap-2">
                      <label className="text-slate100 font-normal text-[10px]">
                        Rest Notes
                      </label>
                      <textarea
                        value={restNotes}
                        onChange={(e) => setRestNotes(e.target.value)}
                        placeholder="Enter notes..."
                        rows={1}
                        className="border border-tblBorder font-normal text-sm text-dark py-2.5 px-3 rounded-md outline-none"
                      />
                    </div>

                    {/* Rest Duration Input */}
                    <div className="flex flex-col gap-2">
                      <label className="text-slate100 font-normal text-[10px]">
                        Rest Duration
                      </label>
                      <input
                        type="text"
                        value={restDuration}
                        onChange={(e) => setRestDuration(e.target.value)}
                        placeholder="Enter duration..."
                        className="border border-tblBorder font-normal text-sm text-dark py-2.5 px-3 rounded-md outline-none"
                      />
                    </div>

                    {/* Save Rest Button */}
                    <div className="flex items-center gap-3">
                      <button
                        onClick={handleSaveRest}
                        className="px-6 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black ml-auto"
                      >
                        Save Rest
                      </button>
                      <button
                        onClick={() => setShowRestForm(!showRestForm)}
                        className="px-4 py-2.5 flex items-center gap-2 bg-white hover:bg-tblHead border border-tblBorder text-dark font-inter font-normal text-sm leading-tight rounded-xl"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {reorderPhasesMode ? (
              // Reorder Mode UI
              <div className="bg-white p-4 rounded-10 border border-tblBorder">
                <h3 className="text-lg font-medium mb-2">
                  Reorder Phases & Rests
                </h3>
                <DndContext onDragEnd={handlePhaseDragEnd}>
                  <ul>
                    {warmupPhases.map((phase, index) => (
                      <DroppablePhase key={phase._id} id={phase._id}>
                        <DraggablePhaseItem
                          key={phase._id}
                          id={phase._id}
                          phaseIndex={index}
                          phase={phase}
                        />
                      </DroppablePhase>
                    ))}
                  </ul>
                </DndContext>
              </div>
            ) : warmupPhases.length > 0 ? (
              warmupPhases.map((phase, phaseIndex) => {
                const isExpanded = expandedPhases[phase._id];

                return (
                  <div
                    key={phaseIndex}
                    className="bg-white border border-black/10 rounded-10"
                  >
                    {/* Phase Header */}
                    <div className="flex flex-wrap justify-between items-center gap-1 md:gap-5 py-4 px-5">
                      <div className="max-md:w-full flex items-center gap-3">
                        <button
                          onClick={() => togglePhaseExpansion(phase._id)}
                          className="p-2 rounded hover:bg-gray-200"
                        >
                          {isExpanded ? (
                            <>
                              <MdKeyboardArrowUp
                                color="#6A7282"
                                size={20}
                                className="rotate-180"
                              />
                            </>
                          ) : (
                            <>
                              <MdKeyboardArrowRight color="#6A7282" size={20} />
                            </>
                          )}
                        </button>

                        {editingPhaseId === phase._id ? (
                          // input / save /cancle btn
                          <div className="max-md:w-full flex max-md:flex-col md:items-center gap-2 ">
                            <input
                              type="text"
                              value={editedTitle}
                              onChange={(e) => setEditedTitle(e.target.value)}
                              className="border border-tblBorder p-3 rounded-10 placeholder:text-slate100 text-sm font-normal leading-tight"
                            />
                            <div className="flex gap-2">
                              <button
                                onClick={() => handleSavePhaseTitle(phase._id)}
                                className="bg-dark border border-tblBorder rounded-10 py-2.5 px-5 text-white font-inter font-medium text-sm leading-tight capitalize hover:bg-black transition"
                              >
                                Save
                              </button>
                              <button
                                onClick={() => setEditingPhaseId(null)}
                                className="bg-white border border-tblBorder rounded-10 py-2.5 px-5 text-dark font-inter font-medium text-sm leading-tight capitalize hover:bg-dark hover:text-white transition"
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        ) : (
                          // name / edit btn
                          <div className="max-md:w-full flex max-md:justify-between items-center gap-2">
                            <h2 className="text-dark text-sm sm:text-base font-medium min-w-40 md:min-w-44">
                              {phase.title}
                            </h2>
                            <button
                              onClick={() =>
                                handleEditPhaseTitle(phase._id, phase.title)
                              }
                              className="p-2 inline-block rounded-md hover:bg-gray-100"
                            >
                              <FiEdit2 color="99A1AF" size={18} />
                            </button>
                          </div>
                        )}
                      </div>

                      {/* Add / Reorder Buttons */}
                      {isExpanded &&
                        (phase.type === "RestPhase" ? (
                          <></>
                        ) : (
                          <>
                            <div className="max-md:w-full flex items-center gap-2">
                              <button
                                onClick={() =>
                                  setPhaseForAddingExercises(
                                    phaseForAddingExercises === phase._id
                                      ? null
                                      : phase._id,
                                  )
                                }
                                className="w-full px-6 py-2.5 bg-dark text-white font-inter font-normal text-xs md:text-sm leading-none rounded-lg hover:bg-black capitalize flex items-center justify-center gap-2"
                              >
                                {phaseForAddingExercises === phase._id ? (
                                  "Cancel"
                                ) : (
                                  <>
                                    <MdAdd color="#fff" />
                                    Add Exercises
                                  </>
                                )}
                              </button>
                              <button
                                onClick={toggleDragMode}
                                className="p-2 rounded hover:bg-gray-200"
                              >
                                {dragMode ? (
                                  <>
                                    {" "}
                                    <FaCheck color="#666666" size={16} />{" "}
                                  </>
                                ) : (
                                  <>
                                    {" "}
                                    <DotedSvg />{" "}
                                  </>
                                )}
                              </button>
                              <button
                                className="p-2 rounded-md hover:bg-gray-200"
                                onClick={() => handleDeletePhase(phase._id)}
                              >
                                <RiDeleteBin4Line color="#666666" size={20} />
                              </button>
                            </div>
                          </>
                        ))}
                    </div>

                    {isExpanded && (
                      <div className="space-y-4 border-t border-black/10">
                        {/* Rest Phase */}
                        {phase.type === "RestPhase" ? (
                          <div className="text-dark text-sm font-normal space-y-1.5 py-4 px-6">
                            <div className="flex items-center gap-3">
                              <strong className="text-slate100 font-normal text-[10px] min-w-20">
                                Rest Duration:
                              </strong>
                              <span className="w-full border-b border-tblBorder font-normal text-xs text-dark py-1 outline-none">
                                {phase.rest_duration || "Not specified"}
                              </span>
                            </div>
                            <div className="flex items-center gap-3">
                              <strong className="text-slate100 font-normal text-[10px] min-w-20">
                                Notes:
                              </strong>
                              <span className="w-full border-b border-tblBorder font-normal text-xs text-dark py-1 outline-none">
                                {phase.rest_notes || "No notes"}
                              </span>
                            </div>
                          </div>
                        ) : (
                          <>
                            {/* Multi-select form */}
                            {phaseForAddingExercises === phase._id && (
                              <div>
                                <MultiSelectExerciseList
                                  exercises={exercises}
                                  onSelectionChange={setSelectedExercises}
                                  resetTrigger={resetTrigger}
                                />
                                <div className="px-4">
                                  <button
                                    onClick={() =>
                                      updatePhaseWithNewExercises(
                                        phase._id,
                                        selectedExercises,
                                      )
                                    }
                                    className="w-full px-6 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-none rounded-lg hover:bg-black capitalize"
                                  >
                                    Save Exercises
                                  </button>
                                </div>
                              </div>
                            )}

                            {/* Exercise List */}
                            <DndContext onDragEnd={handleDragEnd}>
                              {phase.exercises?.length > 0 ? (
                                phase.exercises.map(
                                  (exercise, exerciseIndex) => (
                                    <DroppableExercise
                                      key={exercise._id}
                                      id={exercise._id}
                                    >
                                      <DraggableExerciseItem
                                        phaseIndex={phaseIndex}
                                        phase_id={phase._id}
                                        key={exercise._id}
                                        id={exercise._id}
                                        exerciseIndex={exerciseIndex}
                                        exercise={exercise}
                                        dragMode={dragMode}
                                        onExerciseDelete={handleDeleteExercise}
                                        onFieldChange={handleFieldChange}
                                      />
                                    </DroppableExercise>
                                  ),
                                )
                              ) : (
                                <div className="bg-white px-2 py-8 w-full text-center rounded-b-10 ">
                                  <p className="text-sm font-normal text-[#99A1AF]">
                                    No exercises yet. Click "Add Exercise" to
                                    get started.
                                  </p>
                                </div>
                              )}
                            </DndContext>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <div className="bg-gray-100 p-2 rounded w-fit mx-auto my-2">
                <p className="text-sm text-slate100">
                  No warmup phases available.
                </p>
              </div>
            )}
          </div>

          {/* Right: Form (30%) */}
          <div className="w-full max-w-[1336px]">
            <div className="flex items-center gap-3">
              <button
                onClick={() => setAddPhaseOpen(true)}
                className="flex-1 px-6 py-2.5 border border-black/20 font-normal text-xs md:text-sm leading-none rounded-lg capitalize hover:bg-black/30 transition 
            flex items-center justify-center gap-2"
              >
                <MdAdd color="#000" size={18} />
                Add Phase
              </button>
          
            </div>
            {addPhaseOpen ? (
              <>
                <div className="bg-white border border-black/10 rounded-10 py-4 px-5 mt-4">
                  {/* Phase Name Input / Multi-Select Exercise Dropdown / Save  */}
                  <div className="space-y-4">
                    <div>
                      <label className="block text-slate100 font-normal text-xs mb-2">
                        Phase Name
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Phase Name"
                        value={phase}
                        onChange={(e) => setPhase(e.target.value)}
                        className="w-full p-3 border border-black/10 rounded-lg font-inter font-normal text-sm leading-none"
                      />
                    </div>

                    {/* Multi-Select Exercise Dropdown */}
                    <div>
                      <label className="block text-slate100 font-normal text-xs -mb-2">
                        Assign Exercises
                      </label>
                      <MultiSelectExerciseList
                        exercises={exercises}
                        onSelectionChange={setSelectedExercises}
                        resetTrigger={resetTrigger}
                      />
                    </div>

                    {/* Save Button */}
                    <div className="flex items-center gap-3">
                      <button
                        className="px-6 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-none rounded-lg hover:bg-black capitalize"
                        onClick={handleSave}
                        disabled={loading}
                      >
                        {loading ? "Saving..." : "Save"}
                      </button>
                      <button onClick={() => setAddPhaseOpen(false)}
                        className="bg-transparent border border-tblBorder rounded-10 py-2.5 px-5 text-dark font-inter font-medium text-sm
                   leading-none capitalize hover:bg-dark hover:text-white transition"
                      >
                        cancel
                      </button>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const DraggableExerciseItem = ({
  phaseIndex,
  phase_id,
  id,
  exerciseIndex,
  exercise,
  dragMode,
  onExerciseDelete,
  onFieldChange,
}) => {
  const [isDragging, setIsDragging] = useState(false); // Track dragging state

  const navigate = useNavigate();

  const [videoUrl, setVideoUrl] = useState(""); // Video Modal State
  const [isVideoOpen, setIsVideoOpen] = useState(false); // Toggle Video Modal

  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id,
    enabled: dragMode, // Only enable drag if dragMode is true and delete is not clicked
  });

  const style = transform
    ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
        transition: isDragging ? "none" : "transform 0.2s ease-out", // Smooth transition when not dragging
      }
    : undefined;

  const handleDeleteClick = (event) => {
    event.stopPropagation(); // Prevent drag trigger
    const confirmation = window.confirm(
      `Are you sure you want to delete this exercise?`,
    );
    if (confirmation) {
      //onDelete(item._id, item.type);
      onExerciseDelete(phase_id, exercise._id);
    }
  };

  // Extract YouTube Video ID
  const getYouTubeVideoId = (url) => {
    if (!url) return null;
    const match = url.match(
      /(?:youtube\.com\/(?:[^\/]+\/[^\/]+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]+)/,
    );
    return match ? match[1] : null;
  };

  // Open Video in Modal
  const openVideoModal = (url) => {
    setVideoUrl(url);
    setIsVideoOpen(true);
  };

  // Close Video Modal
  const closeVideoModal = () => {
    setIsVideoOpen(false);
    setVideoUrl("");
  };

  const timeOptions = [
    "None",
    ...Array.from({ length: 18 }, (_, i) => `${(i + 1) * 5}s`),
    ...Array.from({ length: 4 }, (_, i) => `${i + 2}m`),
    ...Array.from({ length: 5 }, (_, i) => `${(i + 2) * 5}m`),
  ];

  return (
    <>
      <div
        ref={setNodeRef}
        {...attributes}
        {...(dragMode ? listeners : {})} // Apply listeners when dragMode is true  // Apply listeners only when dragMode is true
        style={style}
        onMouseDown={() => setIsDragging(true)} // Set dragging state on mouse down
        onMouseUp={() => setIsDragging(false)} // Reset dragging state when mouse is up
      >
        {/* Item Type: Exercise */}
        <div key={id} className="flex flex-col gap-2 w-full py-4 px-5">
          {/* set / rest / time */}
          <div className="flex flex-wrap justify-between gap-3">
            <div className="flex items-center justify-between">
              {/* Video Thumbnail */}
              {exercise?.exercise_id?.video_url ? (
                <div
                  className="w-12 h-12 rounded-md cursor-pointer relative overflow-hidden"
                  onClick={() => openVideoModal(exercise.exercise_id.video_url)}
                >
                  <img
                    src={`https://img.youtube.com/vi/${getYouTubeVideoId(
                      exercise.exercise_id.video_url,
                    )}/hqdefault.jpg`}
                    alt="Exercise Thumbnail"
                    className="w-full h-full rounded-md"
                  />
                  {/* Play Icon */}
                  <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 rounded-md">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={2}
                      stroke="white"
                      className="w-6 h-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M14.752 11.168l-5.197-3.013A1 1 0 008 8v8a1 1 0 001.555.832l5.197-3.013a1 1 0 000-1.668z"
                      />
                    </svg>
                  </div>
                </div>
              ) : (
                <span className="w-16 h-16 bg-gray-200 flex items-center justify-center text-xs rounded-md">
                  No Video
                </span>
              )}

              {/* Exercise Title & Delete Button */}
              <div className="flex-1 flex items-center gap-2">
                {/* Exercise Title */}
                <span className="text-sm font-medium text-dark ml-3">
                  {exercise?.exercise_id?.title || "Unnamed Exercise"}
                </span>
              </div>
            </div>

            <div className="flex flex-wrap gap-3 ml-auto">
              <div className="flex flex-col w-16">
                <label className="text-slate100 font-normal text-[10px]">
                  Sets
                </label>
                <input
                  type="text"
                  value={exercise.sets || ""}
                  onChange={(e) =>
                    onFieldChange(
                      phaseIndex,
                      exerciseIndex,
                      "sets",
                      e.target.value,
                    )
                  }
                  placeholder="Sets"
                  className="border-b border-tblBorder font-normal text-xs text-dark py-1 outline-none mt-1"
                />
              </div>
              <div className="flex flex-col w-16">
                <label className="text-slate100 font-normal text-[10px]">
                  Time
                </label>
                <select
                  value={exercise.time || "None"}
                  onChange={(e) =>
                    onFieldChange(
                      phaseIndex,
                      exerciseIndex,
                      "time",
                      e.target.value,
                    )
                  }
                  className="border-b border-tblBorder font-normal text-xs text-dark py-1 outline-none mt-1"
                >
                  {timeOptions.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
              <div className="flex flex-col w-16">
                <label className="text-slate100 font-normal text-[10px]">
                  Reps
                </label>
                <input
                  type="text"
                  value={exercise.reps || ""}
                  onChange={(e) =>
                    onFieldChange(
                      phaseIndex,
                      exerciseIndex,
                      "reps",
                      e.target.value,
                    )
                  }
                  placeholder="Reps"
                  className="border-b border-tblBorder font-normal text-xs text-dark py-1 outline-none mt-1"
                />
              </div>
              <div className="flex flex-col w-16">
                <label className="text-slate100 font-normal text-[10px]">
                  Distance
                </label>
                <input
                  type="text"
                  value={exercise.distance || ""}
                  onChange={(e) =>
                    onFieldChange(
                      phaseIndex,
                      exerciseIndex,
                      "distance",
                      e.target.value,
                    )
                  }
                  placeholder="Distance"
                  className="border-b border-tblBorder font-normal text-xs text-dark py-1 outline-none mt-1"
                />
              </div>
              <div className="flex flex-col w-16">
                <label className="text-slate100 font-normal text-[10px]">
                  Rest
                </label>
                <input
                  type="text"
                  value={exercise.rest || ""}
                  onChange={(e) =>
                    onFieldChange(
                      phaseIndex,
                      exerciseIndex,
                      "rest",
                      e.target.value,
                    )
                  }
                  placeholder="Rest"
                  className="border-b border-tblBorder font-normal text-xs text-dark py-1 outline-none mt-1"
                />
              </div>
            </div>

            <button
              className="flex-none p-2 rounded hover:bg-gray-100"
              onClick={handleDeleteClick}
            >
              <RiDeleteBin4Line color="#666666" size={20} />
            </button>
          </div>
          {/* notes */}
          <div className="flex items-start gap-3 md:pl-16">
            <label className="text-slate100 font-normal text-[10px] pt-1 -ml-1">
              Notes:
            </label>
            <textarea
              value={exercise.notes || ""}
              onChange={(e) =>
                onFieldChange(
                  phaseIndex,
                  exerciseIndex,
                  "notes",
                  e.target.value,
                )
              }
              rows={1}
              placeholder="Add notes..."
              className="w-full border-b border-tblBorder font-normal text-xs text-dark py-1 outline-none"
            />
          </div>
        </div>
      </div>

      {isVideoOpen && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
          onClick={closeVideoModal}
        >
          <div
            className="bg-white rounded-lg p-4 max-w-3xl w-full relative"
            onClick={(e) => e.stopPropagation()} // Prevent modal close when clicking inside
          >
            {/* Close Button */}
            <button
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-800 bg-white size-10 rounded-full"
              onClick={closeVideoModal}
            >
              ✖
            </button>

            {/* Embed YouTube Video */}
            <iframe
              className="w-full aspect-video rounded-md"
              src={`https://www.youtube.com/embed/${getYouTubeVideoId(videoUrl)}`}
              title="Exercise Video"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
    </>
  );
};

export default DraggableExerciseItem;

export const DraggablePhaseItem = ({ phaseIndex, id, phase }) => {
  const navigate = useNavigate();
  const [dragMode, setDragMode] = useState(true);

  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id,
  });

  const style = transform
    ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
        transition: "none", // Smooth transition when not dragging
      }
    : undefined;

  return (
    <>
      <div
        ref={setNodeRef}
        {...attributes}
        {...(dragMode ? listeners : {})} // Apply listeners when dragMode is true  // Apply listeners only when dragMode is true
        style={style}
      >
        <li
          key={phaseIndex}
          className="bg-tblHead p-3 mb-2 rounded shadow border border-tblBorder text-sm font-medium"
        >
          {phase.title} {phase.type === "RestPhase" ? "(Rest)" : ""}
        </li>
      </div>
    </>
  );
};

const DroppableExercise = ({ id, children }) => {
  const { setNodeRef, isOver } = useDroppable({
    id,
  });

  return (
    <div
      ref={setNodeRef}
      // className={`transition-all duration-150 ease-in-out ${
      //   isOver ? "bg-gray-100" : ""
      // } p-4 rounded-md`}
    >
      {children}
    </div>
  );
};

const DroppablePhase = ({ id, children }) => {
  const { setNodeRef, isOver } = useDroppable({
    id,
  });

  return (
    <div
      ref={setNodeRef}
      className={`transition-all duration-150 ease-in-out ${
        isOver ? "bg-gray-100" : ""
      } p-4 rounded-md`}
    >
      {children}
    </div>
  );
};
